import * as React from 'react';
import styled from 'styled-components';
import { IZScoreDetails } from '../../../../data/providers/reports/zscoreReportProvider';
import { Entity } from '../../../../data/types';
import { Row } from '../../../layout/Row';
import { EPdfMode } from '../../../shared/pdf/Pdf';
import { ZScoreDetail } from './ZScoreDetail';

interface IProps {
  details: IZScoreDetails[];
  colors: string[];
  pdfMode: EPdfMode;
  entity: Entity;
  populationName: string;
}
export const DetailsList = (props: IProps): React.ReactElement => {
  return (
    <Row>
      <Container>
        {props.details
          .filter((item: IZScoreDetails): boolean => item.details.length > 0)
          .map((result: IZScoreDetails, index: number): React.ReactElement => {
            return (
              <ZScoreDetail
                detail={result}
                key={index}
                colors={props.colors}
                pdfMode={props.pdfMode}
                entity={props.entity}
                populationName={props.populationName}
              />
            );
          })}
      </Container>
    </Row>
  );
};

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: var(--grid-gap);
`;
